import Slider from "react-slick";
import { NavLink } from "react-router-dom";
import "./serviceImageSection.scss";
import ServiceSliderImage from "../../../../assets/images/slider-service.png";
import ServiceSliderImage1 from "../../../../assets/images/slider-service1.png";
import ServiceSliderImage3 from "../../../../assets/images/slider-service3.png";
import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";

function SampleNextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className="same-arrow-design right-arrow-design" onClick={onClick}>
      <i className="fa-solid fa-chevron-right"></i>
    </div>
  );
}

function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div className="same-arrow-design left-arrow-design" onClick={onClick}>
      <i className="fa-solid fa-chevron-left"></i>
    </div>
  );
}
export default function ServiceImageSection() {
  const [sliderModalOpen, setSliderModalOpen] = useState(false);
  const propImage: any = [
    {
      original: ServiceSliderImage,
      thumbnail: ServiceSliderImage,
    },
    {
      original: ServiceSliderImage1,
      thumbnail: ServiceSliderImage1,
    },
    {
      original: ServiceSliderImage3,
      thumbnail: ServiceSliderImage3,
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
    ],
  };
  return (
    <div>
      <div className="service-image-slider-section-alignment">
        <div className="container-lg-2">
          <Slider {...settings}>
            <div onClick={() => setSliderModalOpen(!sliderModalOpen)}>
              <div className="grid-items">
                {/* <NavLink to="/kontakt"> */}
                <img src={ServiceSliderImage1} alt="ServiceSliderImage1" />
                {/* </NavLink> */}
              </div>
            </div>

            <div
              className="grid-items"
              onClick={() => setSliderModalOpen(!sliderModalOpen)}
            >
              {/* <NavLink to="/kontakt"> */}
              <img src={ServiceSliderImage} alt="ServiceSliderImage" />
              {/* </NavLink> */}
            </div>
            <div>
              <div
                className="grid-items"
                onClick={() => setSliderModalOpen(!sliderModalOpen)}
              >
                {/* <NavLink to="/kontakt"> */}
                <img src={ServiceSliderImage3} alt="ServiceSliderImage3" />
                {/* </NavLink> */}
              </div>
            </div>
            <div>
              <div
                className="grid-items"
                onClick={() => setSliderModalOpen(!sliderModalOpen)}
              >
                {/* <NavLink to="/kontakt"> */}
                <img src={ServiceSliderImage1} alt="ServiceSliderImage1" />
                {/* </NavLink> */}
              </div>
            </div>

            <div
              className="grid-items"
              onClick={() => setSliderModalOpen(!sliderModalOpen)}
            >
              {/* <NavLink to="/kontakt"> */}
              <img src={ServiceSliderImage} alt="ServiceSliderImage" />
              {/* </NavLink> */}
            </div>
            <div>
              <div
                className="grid-items"
                onClick={() => setSliderModalOpen(!sliderModalOpen)}
              >
                {/* <NavLink to="/kontakt"> */}
                <img src={ServiceSliderImage3} alt="ServiceSliderImage3" />
                {/* </NavLink> */}
              </div>
            </div>
          </Slider>
          <div className="grid"></div>
        </div>
      </div>
      {sliderModalOpen && (
        <div className="slider-modal">
          <div style={{ position: "relative" }}>
            <div
              className="modal-close-alignment"
              onClick={() => setSliderModalOpen(false)}
            >
              <svg
                viewBox="0 0 14 14"
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current w-1-1/4 h-1-1/4 sm:w-2 sm:h-2"
              >
                <path fill="none" d="M1 1l12 12M13 1L1 13"></path>
              </svg>
            </div>

            <ImageGallery items={propImage} />
          </div>
        </div>
      )}
    </div>
  );
}
